/*=====================================
    GameListItem

    Author: Ac
    CreateTime: 2018 / 09 / 28
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
import CupoyImage from 'components/commons/CupoyImage';
/*--------------------------
    Styled
--------------------------*/
const Container = GlobalStyle.BasicBlock.extend`
    position: relative;
    display: inline-block;
    width: 240px;
    height: 246px;
    margin-bottom: 20px;
    cursor: pointer;
    margin-right: ${({ needMarginRight }) => needMarginRight ? `20px` : 0};
`;
const Image = styled.div`
    width: 240px;
    height: 180px;
    background-color: #FFF;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;
const Text = styled.div`
    padding: 14px;
    text-align: center;
    display: -webkit-box;
    overflow : hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #4A4A4A;
    font-size: 17px;
    line-height: 20px;
    height: 66px;
    font-weight: 500;
`;
/*--------------------------
    Main Component
--------------------------*/
class GameListItem extends PureComponent {

    static propTypes = {
        gameid: PropTypes.number.isRequired,
        onClickHandler: PropTypes.func.isRequired,
        needMarginRight: PropTypes.bool,
        title: PropTypes.string.isRequired,
        imgSrc: PropTypes.string,
        gameurl: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.onClickHandler = this.onClickHandler.bind(this);
    }

    onClickHandler() {
        const { gameid, defaultserverid } = this.props;
        this.props.onClickHandler({ gameid, defaultserverid });
    }

    render() {

        const {
            title = '',
            imgSrc = 'about:blank',
            // gameurl,
            needMarginRight,
        } = this.props;

        return (
            <Container
                needMarginRight={needMarginRight}
                onClick={this.onClickHandler}
            >
                <CupoyImage
                    isBackgroundImage
                    stylecomponent={Image}
                    src={imgSrc}
                />
                <Text>{title.trim()}</Text>
            </Container>
        );
    }
}

/*--------------------------
    Export
--------------------------*/
export default GameListItem;